'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var withSideEffect = _interopDefault(require('react-side-effect'));
var React = require('react');
var PropTypes = _interopDefault(require('prop-types'));

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var singleStyle = void 0;

function createStyleDOM(css) {
  var style = document.createElement('style');
  style.textContent = css;
  style.type = 'text/css';
  return style;
}

function setStyle(css) {
  if (!singleStyle) {
    singleStyle = createStyleDOM(css);
    document.head.appendChild(singleStyle);
  } else {
    singleStyle.textContent = css;
  }
  return singleStyle;
}

var DocumentStyle = function (_React$Component) {
  _inherits(DocumentStyle, _React$Component);

  function DocumentStyle() {
    _classCallCheck(this, DocumentStyle);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DocumentStyle.prototype.render = function render() {
    var children = this.props.children;

    if (children) {
      return React.Children.only(this.props.children);
    } else {
      return null;
    }
  };

  return DocumentStyle;
}(React.Component);

DocumentStyle.displayName = 'DocumentStyle';
DocumentStyle.propTypes = {
  css: PropTypes.string.isRequired
};


var index = withSideEffect(function reducePropsToState(propList) {
  return propList.filter(function (x) {
    return !!x.css;
  }).map(function (_ref) {
    var css = _ref.css;
    return css;
  }).join('\n');
}, function handleStateChangeOnClient(css) {
  setStyle(css);
})(DocumentStyle);

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ../~/react-document-style/lib/index.js
// module id = 807
// module chunks = 26